import CustomButton from "../../../components/CustomButton";
import Input, {InputIcon} from "../../../components/form/Input";
import CustomModal from "../../../components/CustomModal";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setManageUserModals, tryChangeUsersPassword} from "../../../redux/slices/manageUserSlice";
import useInput from "../../../hooks/useInput";
import useDidMount from "../../../hooks/useDidMount";
import {
  isValid8CharsPassword,
  isValidConfirmPassword,
  isValidOldPassword,
  isValidPassword,
} from '../../../helpers/validationHelper'


export default function ChangePasswordFormModal({}) {

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [oldPasswordVisible, setOldPasswordVisible] = useState(false);
  const {modal, data} = useSelector((state => state.manageUser.modals.password));
  const dispatch = useDispatch();
  const password = useInput("");
  const confirmPassword = useInput("");
  const oldPassword = useInput("");

  const {
    loading: editing
  } = useSelector((state) => state.dynamicElements.editing);


  const isFormValid = isValidConfirmPassword(confirmPassword.value.trim(), password.value.trim()) &&
    isValidPassword(password.value.trim()) && isValid8CharsPassword(oldPassword.value.trim()) &&
    isValidOldPassword(oldPassword.value.trim(), password.value.trim());


  const submitForm = () => {
    dispatch(tryChangeUsersPassword({
      "new_password": password.value.trim(),
      "old_password": oldPassword.value.trim()

    }));
  };

  useDidMount(() => {
    if (!modal) {
      setPasswordVisible(false);
      setConfirmPasswordVisible(false);
      setOldPasswordVisible(false);
      password.setValue("");
      confirmPassword.setValue("");
      oldPassword.setValue("");
    }
  }, [modal]);


  return (
    <CustomModal title="Change Password"
                 bodyClasses="max-w-screen-sm"
                 showModal={modal}
                 setShowModal={() => dispatch(setManageUserModals())}
                 loading={editing}
                 button={<CustomButton disabled={editing || !isFormValid}
                                       onClick={submitForm}>Confirm</CustomButton>}>
      <div className="flex flex-col p-2 space-y-4">

        <Input disabled={editing} label="Old Password" type={oldPasswordVisible ? 'text' : 'password'} color="lightBlue"
               size="lg" placeholder="Old Password"
               value={oldPassword.value}
               onChange={oldPassword.onChange}
               errorMessage="Invalid old password."
               hideError={isValid8CharsPassword(oldPassword.value.trim(), true)}
               postIcon={
                 <InputIcon
                   icon={oldPasswordVisible ? 'visibility' : 'visibility_off'}
                   onClick={() => setOldPasswordVisible(!oldPasswordVisible)}
                 />
               }
        />


        <Input disabled={editing} label="Password" type={passwordVisible ? 'text' : 'password'} color="lightBlue"
               size="lg" placeholder="Password"
               name="new-password"
               id="new-password"
               autoComplete="new-password"
               value={password.value}
               onChange={password.onChange}
               errorMessage={!isValidOldPassword(oldPassword.value.trim(), password.value.trim(), true)
                 ? "Password mustn't match old password." : "Password must have a special character, both small and capital letter, number and be between 8-16 characters."}
               hideError={isValidPassword(password.value.trim(), true) &&
                 isValidOldPassword(oldPassword.value.trim(), password.value.trim(), true)}
               postIcon={
                 <InputIcon
                   icon={passwordVisible ? 'visibility' : 'visibility_off'}
                   onClick={() => setPasswordVisible(!passwordVisible)}
                 />
               }
        />

        <Input disabled={editing} label="Confirm Password" type={confirmPasswordVisible ? 'text' : 'password'}
               color="lightBlue" size="lg" placeholder="Confirm Password"
               value={confirmPassword.value}
               onChange={confirmPassword.onChange}
               errorMessage="Must match the password."
               hideError={isValidConfirmPassword(confirmPassword.value.trim(), password.value.trim(), true)}
               postIcon={
                 <InputIcon
                   icon={confirmPasswordVisible ? 'visibility' : 'visibility_off'}
                   onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
                 />
               }
        />


      </div>
    </CustomModal>
  );
}